<script>
  import { onMount } from 'svelte';
  import { api } from '../lib/api.js';
  import { printPage } from '../lib/printPage.js';
  import Label from '../components/Label.svelte';

  export let params = {};

  let orders = [];
  let skipped = [];
  let loading = true;
  let error = null;

  // Thermal label stock — applies only while this view is mounted.
  onMount(() => printPage('size: 100mm 148mm; margin: 0;'));

  onMount(async () => {
    const ids = (params.ids || '').split(',').map((s) => s.trim()).filter(Boolean);
    try {
      const results = await Promise.all(
        ids.map((id) => api(`/orders/${id}`).then((d) => d.order).catch(() => ({ failed: id })))
      );
      orders = results.filter((o) => o && !o.failed && o.shippingAddress);
      skipped = results
        .filter((o) => !o || o.failed || !o.shippingAddress)
        .map((o) => (o && o.failed ? '#' + o.failed : (o && o.name) || '?'));
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  });
</script>

{#if loading}
  <p class="msg">Loading labels…</p>
{:else if error}
  <p class="msg err">⚠️ {error}</p>
{:else}
  <div class="controls">
    <a href="#/">← Back</a>
    <button on:click={() => window.print()} disabled={!orders.length}>
      Print {orders.length} label{orders.length === 1 ? '' : 's'}
    </button>
    {#if skipped.length}<span class="skip">Skipped {skipped.length} with no address: {skipped.join(', ')}</span>{/if}
  </div>
  <div class="sheet">
    {#each orders as o (o.id)}
      <Label orderName={o.name} address={o.shippingAddress} customer={o.customer} />
    {/each}
  </div>
{/if}

<style>
  .controls { display: flex; gap: 1rem; align-items: center; margin-bottom: 1rem; flex-wrap: wrap; }
  .controls button { cursor: pointer; padding: .45rem 1rem; border: 0; background: #111; color: #fff; border-radius: 6px; }
  .controls a { color: #1d4ed8; text-decoration: none; }
  .skip { color: #92400e; font-size: .85rem; }
  .msg { color: #555; }
  .err { color: #b00020; }
  .sheet { display: flex; flex-direction: column; gap: 1rem; align-items: flex-start; }

  @media print {
    :global(body) { background: #fff !important; margin: 0 !important; }
    :global(header) { display: none !important; }
    :global(main) { margin: 0 !important; padding: 0 !important; max-width: none !important; }
    .controls { display: none !important; }
    .sheet { gap: 0; }
  }
</style>
